<template>
    <fieldset
        v-editable="props.blok"
        class="radio-wrapper"
        :class="{ '--has-error': validationErrors?.length > 0 }"
        role="radiogroup"
    >
        <legend>{{ props.blok.title }}</legend>
        <div class="input-wrapper">
            <StoryblokComponentWrapper
                v-for="option in props.blok.options"
                :key="option._uid"
                v-model:selected-value="selectedValue"
                :aria-describedby="validationErrors?.length > 0 ? `error-${firstOptionId}` : undefined"
                :aria-invalid="validationErrors?.length > 0"
                :blok="option"
                :group-name="props.blok.title"
            />
            <FormErrors
                :id="firstOptionId"
                :validation-errors="validationErrors"
            />
        </div>
    </fieldset>
</template>

<script lang="ts" setup>
    import { inject } from 'vue';
    import type { FormInputs } from '~/utils/formUtils';
    import { getFormInput } from '~/utils/formUtils';
    import FormErrors from '~/storyblok/Form/FormErrors.vue';

    const props = defineProps<{ blok: FormRadioGroupStoryblok; val: string }>();

    const formInputs = inject<Ref<FormInputs>>('formInputs');
    const validationErrors = computed(() => formInputs?.value[props.blok.inputKey]?.errors ?? []);
    const firstOptionId = computed(() => props.blok.options[0]?._uid ?? props.blok._uid);

    const selectedValue = computed({
        get: () => getFormInput(formInputs?.value, props.blok.inputKey) || null,
        set: (newVal) => {
            if (typeof newVal !== 'undefined' && newVal !== null && formInputs) {
                const input = formInputs.value[props.blok.inputKey];
                if (input) input.value = newVal;
            }
        }
    });
</script>

<style lang="scss" scoped>
    @import '~/assets/scss/form/form-group.scss';
</style>
